import { apiService } from './api';

export const courseEnrollmentService = {
  getAll: async () => {
    try {
      const response = await apiService.get('/CourseEnrollment/all');
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to fetch CourseEnrollments');
    }
  },

  getById: async (id) => {
    try {
      const response = await apiService.get(`/CourseEnrollment/${id}`);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to fetch CourseEnrollment');
    }
  },

  create: async (enrollmentData) => {
    try {
      const response = await apiService.post('/CourseEnrollment/create', enrollmentData);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Course enrollment failed. Please try again.');
    }
  },


  update: async (id,enrollmentData) => {
    try {
      const response = await apiService.put(`/CourseEnrollment/${id}`, enrollmentData);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to update CourseEnrollment');
    }
  },

  delete: async (id) => {
    try {
      const response = await apiService.delete(`/CourseEnrollment/${id}`);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to delete CourseEnrollment');
    }
  }
};  